module.exports = __webpack_public_path__ + "img/logo-light.d8235d55.svg";